export const EXPERIENCES = [
  {
    company: 'CI&T',
    position: 'Engenheiro de Software Sênior',
    startDate: '01/09/2025',
    endDate: '',
    location: 'Campinas, SP · Remoto',
    summary:
      'Referência técnica do squad: definição de padrões de arquitetura, condução de code reviews, mentoria de desenvolvedores e alinhamento técnico com product managers e stakeholders.',
    highlights: [
      'Garanto qualidade de código, consistência arquitetural e desbloqueio de impedimentos técnicos do time.',
      'Desenvolvo microsserviços escaláveis com Node.js e NestJS, com arquitetura hexagonal e orientada a eventos.',
      'Construo APIs REST e GraphQL de alta performance com cache em Redis e otimização de queries em bancos relacionais e NoSQL.',
      'Automatizo deploys na AWS (ECS, Lambda, RDS) com pipelines de CI/CD em GitHub Actions e Docker.',
      'Desenvolvo interfaces com React, Next.js e TypeScript usando Server Components e App Router.',
      'Mantenho observabilidade com Datadog e New Relic para sustentar SLA de 99,9%.',
    ],
    resumeHighlights: [
      'Referência técnica do squad: padrões de arquitetura, code review, mentoria de desenvolvedores e alinhamento com produto e stakeholders.',
      'Microsserviços em Node.js e NestJS com arquitetura hexagonal e orientada a eventos; APIs REST e GraphQL com cache em Redis.',
      'CI/CD com GitHub Actions e Docker na AWS (ECS, Lambda, RDS) e observabilidade com Datadog e New Relic, sustentando SLA de 99,9%.',
    ],
    technologies: [
      'Node.js',
      'NestJS',
      'React',
      'Next.js',
      'TypeScript',
      'AWS',
      'Docker',
      'PostgreSQL',
      'Redis',
      'GraphQL',
    ],
  },
  {
    company: 'Consorciei',
    position: 'Engenheiro de Software Sênior',
    startDate: '01/03/2022',
    endDate: '31/07/2025',
    location: 'São Paulo, SP · Remoto',
    summary:
      'Liderança técnica do squad em uma plataforma de consórcios digitais com parceiros como Itaú, Santander e Porto Seguro: arquitetura de soluções, mentoria, code reviews e padrões de desenvolvimento.',
    highlights: [
      'Mentoria de 5 desenvolvedores júnior e pleno com 1:1s, code reviews estruturados e padrões de Clean Code, SOLID e TDD.',
      'Projetei e implementei microsserviços com NestJS, GraphQL e RabbitMQ, suportando mais de 500 mil requisições por dia com 99,9% de uptime.',
      'Otimizei a infraestrutura AWS com Serverless, Lambda, DynamoDB e Terraform, reduzindo custos em 20% e o tempo de deploy em 60%.',
      'Liderei a migração do monolito para microfrontends com Module Federation, aumentando a autonomia dos squads.',
      'Reduzi o LCP em 40% com SSR/SSG, code splitting e lazy loading, chegando a Lighthouse 95+.',
      'Estabeleci pipeline de qualidade com Jest, Cypress e Testing Library: 85% de cobertura e 30% menos bugs em produção.',
    ],
    resumeHighlights: [
      'Liderança técnica do squad e mentoria de 5 desenvolvedores júnior e pleno com 1:1s, code review e padrões de Clean Code, SOLID e TDD.',
      'Microsserviços com NestJS, GraphQL e RabbitMQ suportando mais de 500 mil requisições por dia com 99,9% de uptime.',
      'Infraestrutura AWS com Serverless, Lambda, DynamoDB e Terraform: redução de 20% no custo e de 60% no tempo de deploy.',
      'Migração do monolito para microfrontends com Module Federation; LCP 40% menor, Lighthouse 95+, 85% de cobertura de testes e 30% menos bugs em produção.',
    ],
    technologies: [
      'Node.js',
      'NestJS',
      'React',
      'Next.js',
      'TypeScript',
      'PostgreSQL',
      'Redis',
      'AWS Lambda',
      'Terraform',
      'GraphQL',
      'Jest',
      'Cypress',
    ],
  },
  {
    company: 'Agência H1 Code',
    position: 'Engenheiro de Software Full Stack',
    startDate: '01/09/2016',
    endDate: '31/03/2022',
    location: 'São Paulo, SP · Remoto',
    summary:
      'Desenvolvimento full stack de aplicações web, evoluindo do front-end para arquiteturas completas de ponta a ponta.',
    highlights: [
      'Desenvolvi APIs REST com Node.js e Express, com autenticação JWT, rate limiting e validação com Joi e Zod.',
      'Modelei bancos MySQL e PostgreSQL e otimizei queries, reduzindo o tempo de resposta em até 50%.',
      'Integrei gateways de pagamento (Stripe, PagSeguro), ERPs e serviços externos com retry policies e circuit breakers.',
      'Apliquei SEO técnico e Web Vitals em mais de 20 projetos, com Lighthouse 90+.',
      'Estabeleci padrões de código (ESLint, Prettier, Husky) e GitFlow em projetos com vários squads.',
    ],
    resumeHighlights: [
      'APIs REST com Node.js e Express (JWT, rate limiting, validação com Zod) e bancos MySQL e PostgreSQL otimizados, com até 50% menos tempo de resposta.',
      'Integrações com pagamentos (Stripe, PagSeguro) e ERPs; SEO técnico e Web Vitals em mais de 20 projetos, com Lighthouse 90+.',
    ],
    technologies: ['Node.js', 'Express', 'React', 'Next.js', 'TypeScript', 'Redux', 'MySQL', 'PostgreSQL', 'GraphQL'],
  },
  {
    company: 'Autônomo',
    position: 'Desenvolvedor Web Full Stack',
    startDate: '01/01/2011',
    endDate: '30/09/2016',
    location: 'São Paulo, SP · Remoto',
    summary:
      'Aplicações web sob demanda para pequenas e médias empresas, em paralelo à atuação na SKY Brasil, do levantamento de requisitos ao deploy.',
    highlights: [
      'Construí sites e sistemas com PHP e JavaScript, evoluindo para Node.js e React ao longo do período.',
      'Integrei aplicações com gateways de pagamento e APIs de terceiros.',
      'Atendi clientes diretamente, traduzindo necessidades de negócio em escopo técnico.',
    ],
    resumeHighlights: [
      'Projetos web de ponta a ponta para pequenas e médias empresas, do levantamento de requisitos ao deploy, com PHP, JavaScript, Node.js e React.',
    ],
    technologies: ['PHP', 'JavaScript', 'MySQL', 'Node.js', 'React'],
  },
  {
    company: 'SKY Brasil',
    position: 'Líder de Equipe Técnica',
    startDate: '01/01/2014',
    endDate: '31/08/2016',
    location: 'São Paulo, SP · Presencial',
    summary:
      'Gestão de time com mais de 30 pessoas, experiência de liderança formal que hoje aplico na condução técnica de squads.',
    highlights: [
      'Melhorei a eficiência operacional em 35% com automação de processos e padronização de workflows.',
      'Criei programa de capacitação interna em novas tecnologias e metodologias ágeis (Scrum e Kanban).',
      'Implementei dashboards de métricas e KPIs para decisões baseadas em dados.',
    ],
    resumeHighlights: [
      'Gestão de time com mais de 30 pessoas; eficiência operacional 35% maior com automação de processos e padronização de workflows.',
    ],
    technologies: ['Liderança', 'Gestão de pessoas', 'Scrum', 'Kanban'],
  },
  {
    company: 'SKY Brasil',
    position: 'Controlador Técnico',
    startDate: '01/01/2008',
    endDate: '31/01/2014',
    location: 'São Paulo, SP · Presencial',
    summary:
      'Gestão operacional de equipes de campo, supervisionando instalações técnicas e garantindo o SLA de atendimento ao cliente.',
    highlights: [],
    resumeHighlights: [],
    technologies: ['Gestão de equipes', 'SLA', 'Atendimento ao cliente'],
  },
];
